import AlertsChannel from "./AlertsChannel";

export default {
  AlertsChannel: AlertsChannel,
};
